import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "./components/common.js";
import Pager from './components/common/pagingUser.vue';
import Editor from "./components/common/editor.vue";
import swal from 'sweetalert';
import VueFileAgent from 'vue-file-agent';
import Validator from './components/common/validation.js';
import validation from 'validator';
import Excel from './components/ynadmin/common/excel.vue';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent);

import DropImg from "./components/common/dragImgFile.vue";
import DropImgAlt from "./components/common/dragImgAlt.vue";

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("editor", Editor);
// Vue.component('dropimg', DropImg);
Vue.component('dropimg', DropImgAlt);

Vue.prototype.$pager = Pager;

new Vue({
	el: "#afterschool",
	data: function() {
		return {
			loading: true,
			fileKey: '',
			selectLocalBoxInApply			: { code: "", value: "" },
			selectSchoolBoxInApply			: { code: "", value: "" },
			selectGradeBoxInApply			: { code: "", value: "" },
			selectTypeBoxInMain				: { code: "", value: "" },
			selectLocalBoxInMain			: { code: "", value: "" },
			selectLocalBoxInSearch			: { code: "", value: "" },
			selectDateTypeBoxInSearch		: { code: "", value: "" },
			selectDomainBoxInSearch			: { code: "", value: "" },
			selectAffiliationBoxInSearch	: { code: "", value: "" },
			selectGradeBoxInSearch			: { code: "", value: "" },
			selectLocalBoxInConnect			: { code: "", value: "", isClick: false },
			selectYearBoxInMeeting			: { year: "" },
			selectHalfYearlyBoxInMeeting	: { halfYearly: "" },
			selectEmailBoxInTeacherApply	: { code: "", value: "" },
			selectDomainBoxInTeacherApply	: { code: "", value: "" },
			selectLocalBoxInTeacherApply	: { code: "", value: "" },
			selectAffilBoxInTeacherSearch	: { code: "", value: "" },
			selectLocalBoxInSpaceApply		: { code: "", value: "" },
			selectEmailBoxInSpaceApply		: { code: "", value: "" },
			selectMajorBoxInSpaceApply		: { code: "", value: "" },
			selectMediumBoxInSpaceApply		: { code: "", value: "" },
			selectMajorBoxInSpaceSearch		: { code: "", value: "" },
			selectMediumBoxInSpaceSearch	: { code: "", value: "" },
			phoneNumberByTeacherApply		: '',
			phoneNumberBySpaceApply			: '',
			admittedCntNumberBySpaceApply	: '',
			surfaceAreaFloatBySpaceApply	: '',
			mainName: "",
			viewModel: {
        keyword: "",
				pager: {
					model		: {},
					pageNo		: 1,
					pageNum		: 1,
					totalSize	: 0,
					rowSize		: 0,
					blockSize	: 0,
					endSize		: 0,
					list		: [],
					href		: "#a",
					etc		: '',
					callBack: function(n) {
						let _etc = this.model.viewModel.pager.etc;
						if(_etc == 'fnGetMainPage'){
							this.model.fnGetMainPage(n);
						} else if(_etc == 'fnGetAfterSchoolSpcList'){
							this.model.fnGetAfterSchoolSpcList(n);
						} else if(_etc == 'fnGetAfterSchoolSpaceDetail'){
							this.model.fnGetAfterSchoolSpaceDetail(n);
						}
					}
				}
			},
			fileImgList			: [],
			filePlanList		: [],
			fileEtcList			: [],
			fileVdList			: [],
			mapViewModel: {
				detailMapAddr	: [],
				listMapAddr		: [],
				map				: null,
				mapInit			: 0
			},
			searchModel: {
				startDate			: "",
				endDate				: "",
				keyword				: "",
				faqCd				: "",
				targetName			: "",
				targetCd			: "",
				searchTypeCd		: "searchType1",
				searchTypeName		: "마을방과후 프로그램",
				sggCd				: "",
				sggName				: "",
				schoolCd			: "",
				schoolName			: "",
				gradeCd				: "",
				gradeName			: "",
				domainCd			: '',
				domainName			: '',
				affiliationCd		: '',
				affiliationName		: '',
				dateTypeCd			: "dateType1",
				dateTypeName		: "접수기간",
				isMentoring			: false,
				sggCdList			: [],
				schoolCdList		: [],
				targetCdList		: [],
				searchTypeList		: [],
				dateTypeList		: [],
				faqCdList			: [],
				emailCdList			: [],
				domainCdList		: [],
				affiliationCdList	: [],
				facilityMajorCdList : [
					{
						tmp: ''
					}
				],
				facilityMediumCdList : [
					{
						tmp: ''
					}
				],
			},
			menuViewModel: {
				isFrstTab: true,
				isScndTab: false,
				isThrdTab: false,
				isFrthTab: false,
				isClick: false,
				tab: 2,
				cnt: 0
			},
			mainModel: {
				fndPrgrBySggList	: [],
				fndTchrBySggList	: [],
				fndSpcBySggList		: [],
				newPrgrList		: [],
				newTchrList		: [],
				newSpcList		: []
			},
			orderModel: {
				isLatest	: true,
				isPopularity	: false,
				orderValue	: '1'
			},
			programModel: {
				programList	: [],
				reviewList	: [],
				qnaList		: [],
				roundList	: [],
				program		: {
					price: 0,
					isPhoto : false,
					isPrivacy: false,
				},
				user		: {},
				review		: {
					title			: "",
					contentFirst	: "",
					vote			: 0,
					uidKey			: "",
					isLike			: false
				},
				qna: {
					title	: "",
					content	: "",
					password: "",
					uidKey	: ""
				},
				uidKey		: "",
				qnaPw		: "",
				participateCnt	: 0,


			},
			selectProFiles:{
				detail : null,
				param : 'PROFILE',
				text : '변경할 이미지를 선택해주세요'
			},
			spaceModel:{
				facilityMjCd:			'',
				facilityMjName:			'',
				facilityMdCd:			'',
				facilityMdName:			'',
				facilityMdEtc:			'',
				spaceName:				'',
				spaceAddr:				'',
				spaceTel:				'',
				spaceEmail:				'',
				majorLevel:				'',
				mediumLevel:			'',
				admittedCnt:			0,
				surfaceArea:			'',
				purpose:				'',
				rentalFee:				0,
				mentoringYn:			'',
				managementAgency:		'',
				link:					'',
				sggName:				'',
				sggCd:					'',
				emailId:				'',
				emailAddr:				'',
				emailCd:				'',
				emailEtc:				'',
				emailOpenYn:			false,
				spaceDto:				{},
				etc:					'',
				direction:				'',
				isArea:					false,
				isProgram:				false,
				isEtc:					false,
				mentoringEtc:			'',

				//유효성
				isSpaceName:			false,
				isSggCd:				false,
				isSpaceAddr:			false,
				isSpaceTel:				false,
				isSpaceEmail:			false,
				isemailAddr:			false,
				isFacilityMjCd:			false,
				isFacilityMdCd:			false,
				isAdmittedCnt:			false,
				isSurfaceArea:			false,
				isPurpose:				false,
				isMentoringYn:			false,
				isRentalFee:			false,
				isManagementAgency:		false,

				validateTxtSpaceName:		'마을공간명은 필수항목입니다.',
				validateTxtSggCd:			'지역선택은 필수항목입니다.',
				validateTxtSpaceAddr:		'주소는 필수항목입니다.',
				validateTxtSpaceTel:		'전화번호는 필수항목입니다.',
				validateTxtSpaceEmail:		'이메일은 필수항목입니다.',
				validateTxtEmailAddr:		'이메일은 필수항목입니다.',
				validateTxtFacilityMjCd: 	'공간분류는 필수항목입니다.',
				validateTxtFacilityMDCd:	'공간분류는 필수항목입니다.',
				validateTxtAdmittedCnt:		'수용인원은 필수항목입니다.',
				validateTxtSurfaceArea:		'면적은 필수항목입니다.',
				validateTxtPurpose:			'용도는 필수항목입니다.',
				validateTxtMentoringYn:		'멘토링 가능여부는 필수항목입니다.',
				validateTxtRentalFee:		'대관료는 필수항목입니다.',
				validateTxtManagementAgency:'운영기관은 필수항목입니다.',
			},
			spaceList: [{}],
			valiObj:{
				isSubject:false
				,isTarget:false
			},
			spaceViewModel:{
				isSubFrstSct:			false,
				isSubScndSct:			true,
			},
		};
	},
	updated: function() {
		let vm = this;
		let pageName = $("#pageName").val();

		if (pageName == "main") {
			$(".mainName").text("");
			$(".btn_back").hide();
		}

    if(pageName == "spaceMain" && vm.menuViewModel.tab == 2 && (vm.menuViewModel.cnt == 1 || vm.menuViewModel.isClick)) {
      vm.fnGetSeoulSvgMap();
      vm.menuViewModel.isClick = false;
		}
	},
	filters: {
		currency: function(value) {
			let num = new Number(value);
			return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
		}
	},
	mounted: function() {
		let vm = this;
		vm.fnOnPageLoad();
	},
	created: function() {
		setTimeout(() => {
			this.loading = false;
		}, 2000);


		let _data = this.$data.orderModel;
		let _keyList = Object.keys(_data);
		for (let values in _keyList) {
			let _values = _keyList[values];
			if (_values.indexOf("CodeList") > -1) {
				_data[_values] = Common.fnBrdOrderingCode();
			}
		}
		$(".const").css("fill", "#FF0000");
		// this.fnGetSeoulGuCode();

    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
	},
	watch: {
		selectedProgram: function(newVal, oldVal) {
			let _color = "#FF0000";
			if (newVal == "1") {
				_color = "#FF0000";
			} else if (newVal == "2") {
				_color = "#FFD8D8";
			} else {
				_color = "#D941C5";
			}
			$(".const").css("fill", _color);
		},
		selectLocalBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != "") {
				this.searchModel.sggName 	= newValue.value;
				this.spaceModel.spaceAddr	= this.spaceModel.addr =='' ? newValue.value: this.spaceModel.addr;
				this.searchModel.sggCd 		= newValue.code;
			} else {
				this.searchModel.sggName 	= "";
				this.spaceModel.spaceAddr	= "";
				this.searchModel.sggCd 		= "";
			}
		},
		selectEmailBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != null && newValue != undefined && newValue != '') {
				this.spaceModel.emailAddr 	= newValue.value;
				this.spaceModel.emailCd 	= newValue.code;
			} else {
				this.spaceModel.emailAddr	= "";
				this.spaceModel.emailCd 	= "";
			}
		},
		selectMajorBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != "") {
				this.spaceModel.facilityMjName 	= newValue.value;
				this.spaceModel.facilityMjCd 	= newValue.code;
			} else {
				this.spaceModel.emailAddr 		= "";
				this.spaceModel.facilityMjName 	= "";
			}
		},

		selectMediumBoxInSpaceApply: function(newValue, oldValue){
			if (newValue != "") {
				this.spaceModel.facilityMdName 	= newValue.value;
				this.spaceModel.facilityMdCd 	= newValue.code;
			} else {
				this.spaceModel.facilityMdName 	= "";
				this.spaceModel.facilityMdCd 	= "";
			}
		},
		selectMajorBoxInSpaceSearch: function(newValue, oldValue){
			if (newValue != "") {
				this.searchModel.facilityMjName = newValue.value;
				this.searchModel.facilityMjCd 	= newValue.code;
			} else {
				this.searchModel.facilityMjName = "";
				this.searchModel.facilityMjCd 	= "";
			}
			this.selectMediumBoxInSpaceSearch = { code: "", value: "" };
			this.fnGetFacilityCodeByMedium(this.searchModel.facilityMjCd);
		},
		selectMediumBoxInSpaceSearch: function(newValue, oldValue){
			if (newValue != "") {
				this.searchModel.facilityMdName = newValue.value;
				this.searchModel.facilityMdCd 	= newValue.code;
			} else {
				this.searchModel.facilityMdName 	= "";
				this.searchModel.facilityMdCd 	= "";
			}
		},
		phoneNumberByTeacherApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\₩]/;
			if(reg.exec(value) !== null ) {

				this.phoneNumberByTeacherApply = value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.phoneNumberByTeacherApply = '';
			}
			this.teacherModel.phone = this.phoneNumberByTeacherApply;
		},
		phoneNumberBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\₩]/;
			if(reg.exec(value) !== null ) {
				this.phoneNumberBySpaceApply = (typeof(value) === 'number') ? value :  value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.phoneNumberBySpaceApply = '';
			}
			this.spaceModel.spaceTel = this.phoneNumberBySpaceApply;
		},
		admittedCntNumberBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\₩]/;
			if(reg.exec(value) !== null ||  reg.exec(value) !== undefined) {
				// this.admittedCntNumberBySpaceApply = (typeof(value) === 'number') ? value :  value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseInt(value))){
				this.admittedCntNumberBySpaceApply = '';
			}
			this.spaceModel.admittedCnt = this.admittedCntNumberBySpaceApply;
		},
		surfaceAreaFloatBySpaceApply(value){
			let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\/\`\₩]/;
			if(reg.exec(value) !== null ) {
			// 	this.surfaceAreaFloatBySpaceApply = (typeof(value) === 'number') ? value :  value.replace(/[^0-9]/g,'');
			}

			if(isNaN(parseFloat(value))){
				this.surfaceAreaFloatBySpaceApply = '';
			}
			this.spaceModel.surfaceArea = this.surfaceAreaFloatBySpaceApply;
		},



	},
	methods: {
		fnOnPageLoad: function() {
			let pageName = $("#pageName").val();

			if(pageName == 'spaceMain'){
				this.mainName = "마을공간";
				// this.fnGetAfterSpaceSearchPage();
				if($("#tab").val() != null && $("#tab").val() != ""){
					this.fnChgTab($("#tab").val(), true);
				}else{
					this.fnChgTab(2, true);
				}
			} else if(pageName == 'spaceList'){
				this.mainName = "마을공간 등록내역";
        		this.fnGetAfterSpaceListSessionStorage();
				this.fnGetMainPage(this.viewModel.pager.pageNo);
			}
		},
	// 마을공간 찾기 히스토리 백 (지도)
	fnSetAfterSpaceSearchSessionStorage() {
		let vm = this;

		let backData = [{
			pageNo 		: vm.viewModel.pager.pageNo,
			sggCd 		: vm.searchModel.sggCd,
			mapInit 	: vm.mapViewModel.mapInit,
			facilityMjCd : vm.searchModel.facilityMjCd,
			facilityMdCd : vm.searchModel.facilityMdCd,
			keyword		: vm.searchModel.keyword,
			orderValue	: vm.orderModel.orderValue,
			isMentoring : vm.searchModel.isMentoring
		}];
		sessionStorage.setItem('afterSpace.search', JSON.stringify(backData));
	},
	fnGetAfterSpaceSearchSessionStorage() {
		let vm = this;
		let backData;
		if (sessionStorage.getItem('afterSpace.search') != null) {
		  backData = JSON.parse(sessionStorage.getItem('afterSpace.search'));
		  sessionStorage.removeItem('afterSpace.search');

		  vm.viewModel.pager.pageNo = backData[0].pageNo
		  vm.searchModel.sggCd = backData[0].sggCd
		  vm.mapViewModel.mapInit = backData[0].mapInit
		  vm.searchModel.facilityMjCd = backData[0].facilityMjCd
		  vm.searchModel.facilityMdCd = backData[0].facilityMdCd
		  vm.searchModel.keyword = backData[0].keyword
		  vm.orderModel.orderValu = backData[0].orderValue
		  vm.searchModel.isMentoring = backData[0].isMentoring

		  vm.fnGetAfterSchoolSpcList(vm.viewModel.pager.pageNo);

		}
	},

    // 마을공간 등록내역 히스토리 백
    fnSetAfterSpaceListSessionStorage() {
      let vm = this;
      let backData = [{
        pageNo : vm.viewModel.pager.pageNo,
        keyword : vm.viewModel.keyword,
      }]
      sessionStorage.setItem('afterSpace.list', JSON.stringify(backData));
    },
    fnGetAfterSpaceListSessionStorage() {
      let vm = this;
      let backData;
      if (sessionStorage.getItem('afterSpace.list') != null) {
        backData = JSON.parse(sessionStorage.getItem('afterSpace.list'));
        sessionStorage.removeItem('afterSpace.list');

        vm.viewModel.pager.pageNo = backData[0].pageNo;
        vm.keyword = backData[0].keyword;
      }
    },

		//마이내비 등록내역
		fnGetMainPage: function(pageNumber) {
			let vm = this;
			vm.viewModel.pager.rowSize = 10;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let _param = {
                mynaviYn  : 'Y'
              , keyword   : vm.viewModel.keyword
              };
			let param = { param 		: _param
				    	, pageNo		: vm.viewModel.pager.pageNo
				    	, pageSize		: vm.viewModel.pager.rowSize
				    	};
      console.log("param",param)
			Axios.post("/api/afterschool/space/list", param).then(function(response) {
				vm.spaceList = response.data.paramSpcDtoList;
				vm.spaceList.forEach(function(item) {
					item.spaceTel = vm.fnChgTelNum(item.spaceTel);
				});
				// vm.fnSetPager(response.data.paramListCnt,'fnGetAfterSchoolSpcList');
        vm.fnSetPager(response.data.paramListCnt,'fnGetMainPage');
			}).catch(function(ex) {
				console.log(ex);
			});

		},

		//시군구 코드 조회
		fnGetSeoulGuCode: function() {
			let vm = this;
			let _param = {};
			let param = {param:_param};
			let _pageName = $("#pageName").val();
			Axios.post("/api/afterschool/code/sgg", param).then(function(response) {
				let _sggParam = $("#sggCd").val();
				if(response.data.paramCdDtoList !=null && response.data.paramCdDtoList.length != 0){
					response.data.paramCdDtoList.forEach(function(item) {
						let val = { code: item.sggCd, value: item.sggName };
						vm.searchModel.sggCdList.push(val);
						if (vm.menuViewModel.isFrstTab) {

							if (item.sggCd == vm.spaceModel.ssgCd) {
								vm.selectLocalBoxInSearch = {
									code: item.sggCd,
									value: item.sggName
								};
							}
						}
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//영역 코드 조회
		// fnGetDomainCode: function() {
		// 	let vm = this;
		// 	let param = {};
		// 	Axios.post("/api/afterschool/code/domain", param).then(function(response) {
		// 		response.data.paramCdDtoList.forEach(function(item) {
		// 			let val = { code: item.targetCd, value: item.targetTitle };
		// 			vm.searchModel.domainCdList.push(val);
		// 		});
		// 	}).catch(function(ex) {
		// 		console.log(ex);
		// 	});
		// },
		//계열 코드 조회
		fnGetAffiliationCode: function() {
			let vm = this;
			let param = {};
			let _pageName = $("#pageName").val();
			Axios.post("/api/afterschool/code/affiliation", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let val = { code: item.targetCd, value: item.targetTitle };
					vm.searchModel.affiliationCdList.push(val);
					if (_pageName == "teacherApply") {
						if (item.targetCd == vm.teacherModel.affiliationCd) {
							vm.selectDomainBoxInTeacherApply = {
								code: item.targetCd,
								value: item.targetTitle
							};
						}
					} else if (_pageName == "tchrDetail") {
						if (item.targetCd == vm.teacherModel.affiliationCd) {
							vm.selectDomainBoxInTeacherApply = {
								code: item.targetCd,
								value: item.targetTitle
							};
						}
					}
				});

			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//대상 코드 조회-option이 apply면 초,중,고 외 대상코드 제외
		fnGetTargetCode: function(option, _schoolCd, _targetCd) {
			let vm = this;
			let _param = { schoolCd : _schoolCd };
			let param = {param : _param};
			Axios.post("/api/afterschool/code/target", param).then(function(response) {
				if (option == "apply") {
					let school = response.data.paramCdDto;
					let schoolType = "";
					if(school != null){
						if (school.schoolName.indexOf("초등학교") > -1) {
							schoolType = "초등학교";
						} else if (school.schoolName.indexOf("중학교") > -1) {
							schoolType = "중학교";
						} else if (school.schoolName.indexOf("고등학교") > -1) {
							schoolType = "고등학교";
						}
					}
					response.data.paramCdDtoList.forEach(function(item) {
						if (item.targetCd.indexOf("000") == -1) {
							if (item.targetTitle.indexOf(schoolType) > -1) {
								let val = { code: item.targetCd, value: item.targetTitle };
								vm.searchModel.targetCdList.push(val);
							}
						}
					});

					if (!vm.fnIsEmptyChk(_targetCd)) {
						vm.searchModel.targetCdList.forEach(function(item) {
							if (item.code == _targetCd) {
								vm.selectGradeBoxInApply = item;
							}
						});
					}
				} else {
					response.data.paramCdDtoList.forEach(function(item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.targetCdList.push(val);
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});

		},
		//전체지역 코드 조회
		fnGetLocalCode: function(_sggCd) {
			let vm = this;
			let _param = {};
			let param = {param:_param};
			let _pageName = $('#pageName').val();
			Axios.post("/api/afterschool/code/local", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let _sggName = item.sido + " " + item.sggName;
					let val = { code: item.sggCd, value: _sggName };
					vm.searchModel.sggCdList.push(val);
				});
				vm.searchModel.sggCdList.forEach(function(object) {
					if (_pageName == "spaceMain") {
						if ( object.code == vm.searchModel.sggCd
							|| object.code == vm.spaceModel.sggCd) {
							vm.spaceModel.sggName = object.value;
							vm.selectLocalBoxInSpaceApply = {
								code: object.code,
								value: object.value
							};
						}
					} else if (object.code == _sggCd) {
						vm.selectLocalBoxInApply = object;
					}
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//지역별 학교 코드 조회
		fnGetSchoolCode: function(_sggCd, _schoolCd) {
			let vm = this;
			let _param = { sggCd: _sggCd };
			let param = {param : _param};
			Axios.post("/api/afterschool/code/school", param).then(function(response) {
				response.data.paramCdDtoList.forEach(function(item) {
					let val = {
						code: item.schoolCd,
						value: item.schoolName,
						type: item.schoolType
					};
					vm.searchModel.schoolCdList.push(val);
				});
				vm.searchModel.schoolCdList.forEach(function(object) {
					if (object.code == _schoolCd) {
						vm.selectSchoolBoxInApply = object;
					}
				});
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을방과후 공간 목록 조회
		fnGetAfterSchoolSpcList: function(pageNumber, _sggCd) {
			let vm = this;
			pageNumber ? pageNumber : 1;
			vm.viewModel.pager.rowSize = 6;
			vm.viewModel.pager.blockSize = 5;
			vm.viewModel.pager.pageNo = pageNumber;
			let tmpSggCd = '';
			if(_sggCd != null && _sggCd !=''){
				tmpSggCd = _sggCd;
			} else {
				tmpSggCd = vm.searchModel.sggCd;
			}
			let _param = { sggCd 		: tmpSggCd
						 , facilityMjCd : vm.searchModel.facilityMjCd
						 , facilityMdCd : vm.searchModel.facilityMdCd
						 , mentoringYn	: (vm.searchModel.isMentoring ? "Y" : "")
						 , keyword		: vm.searchModel.keyword
						 , orderValue	: vm.orderModel.orderValue
						 };
			let param = { param 		: _param
				    	, pageNo		: vm.viewModel.pager.pageNo
				    	, pageSize		: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/space/list", param).then(function(response) {
				if(response.data.paramSpcDtoList != null){
					vm.spaceList = response.data.paramSpcDtoList;
				}
				vm.fnSetPager(response.data.paramListCnt,'fnGetAfterSchoolSpcList');
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//탭 변환
		fnChgTab: function(tab, isReset) {
			let vm = this;
			let pageName = $("#pageName").val();

			if(isReset){
				vm.fnChgValInitBySpc();
			}
			vm.menuViewModel.tab = tab;
			//마을공간 등록
			if (vm.menuViewModel.tab == 1) {
				if(pageName == 'spaceMain'){
					if(!isReset){
						vm.spaceModel.isUpdate = true;
					}

					vm.fnGetSpaceApply();
					vm.fnGetImgFileKeyBySpace();


				}
				vm.menuViewModel.isFrstTab = true;
				vm.menuViewModel.isScndTab = false;
			//마을공간 찾기
			} else if (vm.menuViewModel.tab == 2) {
				if(pageName == 'spaceMain'){
					vm.fnGetFacilityCodeByMajor();
					// vm.fnGetFacilityCodeByMedium();
					let _uidKey = $('#uidKey').val();
					if(_uidKey != null && _uidKey != ''){
						vm.fnChgSubTabBySpc(2, _uidKey);
					} else {
						vm.fnGetAfterSpaceSearchPage();
					}
				}
				vm.menuViewModel.isFrstTab = false;
				vm.menuViewModel.isScndTab = true;
				vm.menuViewModel.isClick = true;


			}



			// document.querySelectorAll('input').forEach(x => {
			// 	console.log(x);

			// 	if(x.type == 'hidden') x.tabIndex = -1;
			// 	else  x.tabIndex = 500;


			// });

			// document.querySelectorAll('a').forEach(x => {
			// 	console.log(x);

			// 	if(x.type == 'hidden') x.tabIndex = -1;
			// 	else   x.tabIndex = 500;

			// });

			// document.querySelectorAll('button').forEach(x => {
			// 	console.log(x);

			// 	if(x.type == 'hidden') x.tabIndex = -1;
			// 	else   x.tabIndex = 500;

			// });
		},
		//정렬 변환
		fnChgOrder: function(order) {
			let vm = this;
			let pageName = $('#pageName').val();
			// 최신순
			if (order == "1") {
				vm.orderModel.isLatest = true;
				vm.orderModel.isPopularity = false;
				vm.orderModel.orderValue = order;
			/*  프로그램 : 인기순
				마을강사 : 이름순
				마을공간 : 이름순 */
			} else if (order == "2") {
				vm.orderModel.isLatest = false;
				vm.orderModel.isPopularity = true;
				vm.orderModel.orderValue = order;
			}
			if(pageName == 'spaceMain'){
				vm.fnGetAfterSchoolSpcList(1);
			}
		},
		//마을공간 하위 탭 변경
		fnChgSubTabBySpc: function(tab, _uidKey){
			let vm = this;
			//목록
			if(tab == 1){
				vm.fnGetSearchBySpace();
				vm.spaceViewModel.isSubFrstSct = true;
				vm.spaceViewModel.isSubScndSct = false;
			//상세
			}else if(tab == 2){
				vm.fnGetAfterSchoolSpaceDetail(1, _uidKey);
				vm.spaceViewModel.isSubFrstSct = false;
				vm.spaceViewModel.isSubScndSct = true;
				this.scrollToTop();
				setTimeout(() => {
					//마을방과후 - 마을공간 슬라이드
					spaceSlide1();

					$(".navi.prev").attr("tabindex", 500);
					$(".navi.next").attr("tabindex", 500);
				}, 500);
			}
		}
		,
		//메뉴링크-마을강사
		onClickAfterTeacher(sggCd) {
			let uri = "/customer/afterschool/teacher" ;
			if (sggCd != null && sggCd != "") {
				uri += "?sggCd=" + sggCd;
			}
			location.href = uri;
		},
		//메뉴링크-마을공간
		onClickAfterSpace(sggCd) {
			let uri = "/customer/afterschool/space";
			if (sggCd != null && sggCd != "") {
				uri += "?sggCd=" + sggCd;
			}
			location.href = uri;
		},
		//메뉴링크-마을방과후 이음
		onClickAfterNotice() {
			location.href = "/customer/afterschool/connect";
		},
		//메뉴링크-청소년 모임터
		onClickAfterMeetingPlace() {
			location.href = "/customer/afterschool/meetingPlace";
		},

		//에디터 사용
		onEditorChange: function(event) {
			let vm = this;
			// this.viewModel.detail.cmm_cntnt = event.html;
			if (vm.programViewModel.isThrdTab) {
				vm.programModel.review.contentFirst = event.html;
			} else if (vm.programViewModel.isFrthTab) {
				vm.programModel.qna.content = event.html;
			} else if ( vm.meetingViewModel.isThrdSct || vm.meetingViewModel.isFrthSct) {
				vm.meetingModel.galleryVO.contentFirst = event.html;
			} else if (vm.teacherViewModel.isSubThrdSct || vm.teacherViewModel.isSubFrthSct){
				vm.teacherModel.brdDetail.content = event.html;
			}
			this.$emit("getEditorInfo", event);
		},

		//페이징 처리
		fnSetPager: function(totalCount, etc){
			let vm = this;
			vm.viewModel.pager.etc = etc
			vm.viewModel.pager.totalSize = totalCount;
			vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
			Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
		},
		//지도 바꾸기 - mainPage
		fnOnChangeMap: function() {
			let vm = this;
			$("body").load("svg g", function() {
				vm.fnChgVal();
				vm.fnOnLoadColorMap();
			});
		},
		//메뉴별 지도 설정 - 각 메뉴 메인페이지
		fnSetMap: function(_pageName){
			let vm = this;
			$("body").load("svg g", function() {
				if(_pageName == 'spaceMain'){
					vm.mainModel.fndSpcBySggList.forEach(function(object) {
						let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
						_isClass.text("");
						_isClass.append("(" +object.sggCdCnt +")");
						_isClass.css('fill', 'black');
						$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
					});
          vm.fnOnLoadColorMapBySpcPage();
				}
			});
		},
		fnChgVal: function(){
			let vm = this;
			if (vm.selectTypeBoxInMain.code == "searchType3") {
				vm.mainModel.fndSpcBySggList.forEach(function(object) {
					let _isClass = $('svg g TEXT tspan'+'#CNT'+object.sggCd)
					_isClass.text("");
					_isClass.append("(" +object.sggCdCnt +")");
					_isClass.css('fill', 'black');
					$('svg g text'+ ' ' +'#CNT'+object.sggCd).val(object.sggCdCnt);
				});
			}
		},
		fnOnLoadColorMap: function() {
			let vm = this;
			if (vm.selectTypeBoxInMain.code == "searchType2") {
				$("svg g path").css("fill", "#ecd5cd");
			} else if (vm.selectTypeBoxInMain.code == "searchType3") {
				$("svg g path").css("fill", "#d1e3e7");
			} else {
				$("svg g path").css("fill", "#eee4c2");
			}
		},
		fnOnLoadColorMapBySpcPage: function() {
			let vm = this;
			let _sggCd = vm.mapViewModel.mapInit ? vm.mapViewModel.mapInit : $('#sggCd').val();
			if(_sggCd != null && _sggCd != ''){
				vm.mapViewModel.mapInit = _sggCd;
			}
			if(vm.mapViewModel.mapInit == 0){
				$("body").load("svg g", function() {
					$("svg g path").css("fill", "#d1e3e7");
				});
			} else {
				$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#d1e3e7");
				$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#5ac1da");
			}
		},

		// svg 지도 불러오기-초기 지도 화면 셋팅
		fnGetSeoulSvgMap: function() {
			let vm = this;
			let _pageName = $('#pageName').val();
			Axios.get("/design/common/images/seoul_svg.svg").then(function(response) {
				vm.mapViewModel.map = response.data;
				if(_pageName == 'main'){
					vm.fnOnChangeMap();
				} else {
					if(_pageName == 'spaceMain'){
						vm.fnOnLoadColorMapBySpcPage();
					}
					setTimeout(() => {
						vm.fnSetMap(_pageName);
					}, 200);
				}
			}).catch(function(ex) {
				console.log(ex);
			});
			vm.addClickHandler();
		},
		addClickHandler: function() {
			let vm = this;
			let _pageName = $('#pageName').val();
			$("body").off().on("click", "svg path, text", function(evt) {
				let _id = evt.target.id;
				vm.mapViewModel.mapInit = _id.substring(3, 8);
				$("svg path").not("#MAP" + vm.mapViewModel.mapInit).css("fill", "#d1e3e7");
				$("#MAP" + vm.mapViewModel.mapInit).css("fill", "#5ac1da");
				vm.searchModel.sggCd = vm.mapViewModel.mapInit;
				vm.fnGetAfterSchoolSpcList(1, vm.mapViewModel.mapInit);
				vm.menuViewModel.cnt++;
			});
		},
		//날짜데이터 변환
		fnChkDateVal: function(date){
			let _tmpStrDt = '';
			let _tmp = new Date('1970-01-01');
			if(date.getTime() == _tmp.getTime()){
				date = '';
			}

			if(!isNaN(date) && date != '' ){
				let tmpMonth = date.getMonth() + 1;
				let tmpDate = date.getDate();
				if(tmpMonth < 10){
					tmpMonth = '0'+ String(tmpMonth);
				}
				if(tmpDate < 10){
					tmpDate = '0'+ String(tmpDate);
				}
				_tmpStrDt = date.getFullYear()+"-"+tmpMonth+"-"+tmpDate;
			} else {
				_tmpStrDt = null;
			}
			return _tmpStrDt;
		},

		//좋아요 버튼 클릭
		fnChgLikeButton: function(object){

			//로그인 체크
			let _userKey = $("#loginUserKey").val();
			if (this.fnIsEmptyChk(_userKey)) {
				swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
			}
			//로그인이 되어 있으면
			object.isLike = !object.isLike;
			let vm = this;
			let _param = { uidKey       : object.uidKey
						, rcmmUidKey    : object.rcmmUidKey
						, isLike        : object.isLike
						};
			let param = {param : _param};
			Axios.post("/api/afterschool/board/like/update", param).then(function(response) {
				let result = response.data.result
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//이메일 코드 가져오기
		fnGetEmailCode: function(){
			let vm = this;
			let _pageName = $('#pageName').val();
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/code/email", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					vm.searchModel.emailCdList = [];
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.emailCdList.push(val);
					});
					if((vm.spaceModel.tmpEmailCd != null && vm.spaceModel.tmpEmailCd != undefined && vm.spaceModel.tmpEmailCd != '')){
								vm.spaceModel.emailCd = vm.spaceModel.tmpEmailCd;
								vm.searchModel.emailCd = vm.spaceModel.tmpEmailCd;
					}
					if (_pageName == "spaceMain") {
						if(vm.searchModel.emailCd != null && vm.searchModel.emailCd != undefined ){
							vm.searchModel.emailCdList.forEach(function (item) {
								if (item.targetCd == vm.searchModel.emailCd) {
									vm.spaceModel.emailName = item.targetTitle;
									vm.selectEmailBoxInSpaceApply = {
										code: item.targetCd,
										value: item.targetTitle
									};
									return false;
								}
							});
						} else{
							vm.selectEmailBoxInSpaceApply = {
								code: '',
								value: vm.spaceModel.emailAddr
							};
						}
					}
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//영역 코드 가져오기
		fnGetDomainCode: function(){
			let vm = this;
			let _param = {};
			let param = {param:_param};
			let _pageName = $('#pageName').val();
			Axios.post("/api/afterschool/code/domain", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					if(vm.menuViewModel.tab==3){
						vm.searchModel.domainCdList.push({
							code	: "",
							value	: "전체"
						});
					}
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.domainCdList.push(val);
					});
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을공간 등록화면 구성
		fnGetSpaceApply: function(){
			let vm = this;
			//시군구코드 가져오기
			vm.fnGetLocalCode();
			//이메일코드 가져오기
			vm.fnGetEmailCode();
			//공간코드 가져오기
			vm.fnGetFacilityCodeByMajor();
		},
		//대분류 공간코드 조회
		fnGetFacilityCodeByMajor: function(){
			let vm = this;
			let _param = {};
			let param = {param : _param};
			let _pageName = $('#pageName').val();
			Axios.post("/api/afterschool/code/facility/major", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					vm.searchModel.facilityMajorCdList = [];
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.facilityMajorCdList.push(val);
						if (_pageName == "spaceMain") {
							if (item.targetCd == vm.searchModel.facilityMjCd) {
								vm.spaceModel.facilityMjName = item.targetCd;
								vm.selectMajorBoxInSpaceApply = {
									code: item.targetCd,
									value: item.targetTitle
								};
							}
						}
					});
				}
				vm.menuViewModel.cnt++;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//중분류공간코드 조회
		fnGetFacilityCodeByMedium: function(facilityMjCd){
			let vm = this;
			let _param = { groupCode: facilityMjCd};
			let param = {param : _param};
			let _pageName = $('#pageName').val();
			Axios.post("/api/afterschool/code/facility/medium", param).then(function(response) {
				if(response.data.paramCdDtoList != null && response.data.paramCdDtoList.length != 0){
					vm.searchModel.facilityMediumCdList = [];
					response.data.paramCdDtoList.forEach(function (item) {
						let val = { code: item.targetCd, value: item.targetTitle };
						vm.searchModel.facilityMediumCdList.push(val);
						if (_pageName == "spaceMain") {
							if (item.targetCd == vm.searchModel.facilityMdCd) {
								vm.spaceModel.facilityMdName = item.targetCd;
								vm.selectMediumBoxInSpaceApply = {
									code: item.targetCd,
									value: item.targetTitle
								};
							}
						}
					});
				}
				vm.menuViewModel.cnt++;
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//공간코드 기타 값 초기화
		fnInitEtcValue: function(facilityMdCd){
			if(facilityMdCd != 'FCTNVADMNV01016' ||  facilityMdCd != 'FCTNVADMNV02006'){
				this.spaceModel.facilityMdEtc = '';
			}
		},
		//마을공간 등록
		fnSetSpace: function(){
			let vm = this;
			let _mtrDetail = 	(vm.spaceModel.isArea ? "Y" : "N") +'|' +
								(vm.spaceModel.isProgram ? "Y" : "N") +'|' +
								(vm.spaceModel.isEtc ? "Y" : "N");
			let tmp = '';
			if(vm.spaceModel.mentoringYn == 'Y'){
				tmp = _mtrDetail
			}

			let tmpEtc = '';
			if(vm.spaceModel.isEtc){
				tmpEtc = vm.spaceModel.mentoringEtc
			}

			//유효성체크
			let _IsSpaceName	= validation.isEmpty(vm.spaceModel.spaceName);
			let _IsSggCd		= validation.isEmpty(vm.searchModel.sggCd);
			let _IsAddress		= validation.isEmpty(vm.spaceModel.spaceAddr);
			let _IsPhonNum		= validation.isEmpty(vm.spaceModel.spaceTel);
			let _IsEmailId		= validation.isEmpty(vm.spaceModel.emailId);
			let _IsEmailAddr	= false;
      if(vm.spaceModel.emailCd == '' || vm.spaceModel.emailCd == null || vm.spaceModel.emailCd == undefined){
        // _IsEmailAddr	= validation.isEmpty(vm.spaceModel.emailEtc);
        if (vm.spaceModel.emailEtc == '' || vm.spaceModel.emailEtc == null || vm.spaceModel.emailEtc == undefined){
          _IsEmailAddr	= true;
        }
      }
			let _IsMjCd			= validation.isEmpty(vm.spaceModel.facilityMjCd);
			let _IsMdCd			= validation.isEmpty(vm.spaceModel.facilityMdCd);
			let _IsFacilityEtc 	= false;
			if(vm.spaceModel.facilityMdCd == 'FCTNVADMNV01016'
			 || vm.spaceModel.facilityMdCd == 'FCTNVADMNV02006'){
				_IsFacilityEtc 	= validation.isEmpty(vm.spaceModel.facilityMdEtc);
			}
			let _IsAdmittedCnt	= validation.isEmpty(vm.spaceModel.admittedCnt);
			let _HasAdmittedCnt	= vm.spaceModel.admittedCnt > 0 ? false : true;
			let _IsSurfaceArea	= validation.isEmpty(vm.spaceModel.surfaceArea);
			let _HasSurfaceArea	= vm.spaceModel.surfaceArea > 0 ? false : true;
			let _IsPurpose		= validation.isEmpty(vm.spaceModel.purpose);

			let _IsArea			= false;
			let _IsProgram		= false;
			let _IsEtc			= false;
			let _IsMentoring	= false;
			let _IsMentoringEtc	= false;
			if(vm.spaceModel.mentoringYn == 'Y'){
				_IsArea		= vm.spaceModel.isArea;
				_IsProgram	= vm.spaceModel.isProgram;
				_IsEtc		= vm.spaceModel.isEtc;
				if(!_IsArea && !_IsProgram && !_IsEtc){
					_IsMentoring = true;
				}
				if(vm.spaceModel.isEtc){
					_IsMentoringEtc	= validation.isEmpty(vm.spaceModel.mentoringEtc);
				}
			}

			let _IsRentailFee	= validation.isEmpty(vm.spaceModel.rentalFee);
			let _IsAgency		= validation.isEmpty(vm.spaceModel.managementAgency);

			let _word = '';
			let _resultInput 	= false;
			let _resultChoice 	= false;
			let _comment		= '';
			if(_IsSpaceName){
				_word = '마을공간명';
				_resultInput 	= true;
			} else if(_IsSggCd){
				_word = '지역';
				_resultChoice 	= true;
			} else if(_IsAddress){
				_word = '상세주소';
				_resultInput 	= true;
			} else if(_IsPhonNum){
				_word = '전화번호';
				_resultInput 	= true;
			} else if(_IsEmailId){
				_word = '이메일 계정';
				_resultInput 	= true;
			} else if(_IsEmailAddr){
				_word = '이메일 주소';
				_resultInput 	= true;
			} else if(_IsMjCd){
				_word = '공간 대분류';
				_resultChoice 	= true;
			} else if(_IsMdCd){
				_word = '공간 중분류';
				_resultChoice 	= true;
			} else if(_IsFacilityEtc){
				_word = '공간 분류 기타';
				_resultChoice 	= true;
			} else if(_IsAdmittedCnt){
				_word = '수용인원';
				_resultInput	= true;
			} else if(_HasAdmittedCnt){
				_word = '수용인원';
				_comment		= '1명 이상을 입력해야 됩니다.'
			} else if(_IsSurfaceArea){
				_word = '면적';
				_resultInput 	= true;
			} else if(_HasSurfaceArea){
				_word = '면적';
				_comment		= '0이상의 숫자를 입력해야 됩니다.'
			} else if(_IsPurpose){
				_word = '용도';
				_resultInput 	= true;
			} else if(_IsMentoring){
				_word = '멘토링 가능여부';
				_comment		= '세부 영역 중 1개 이상을 선택해야 됩니다.'
			} else if(_IsMentoringEtc){
				_word = '멘토링 기타(입력)';
				_resultInput 	= true;
			} else if(_IsRentailFee){
				_word = '대관료';
				_resultInput 	= true;
			} else if(_IsAgency){
				_word = '운영기관';
				_resultInput 	= true;
			}

			if (_resultChoice){
				swal({
					title       : _word+' 오류',
					text        : _word+'을/를 선택해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else if( _resultInput) {
				swal({
					title       : _word+' 오류',
					text        : _word+'을/를 입력해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else if( _HasAdmittedCnt || _IsMentoring || _HasSurfaceArea) {
				swal({
					title       : _word+' 오류',
					text        : _comment,
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else {
				let _param = { spaceName 	: vm.spaceModel.spaceName
							 , sggCd	 	: vm.searchModel.sggCd
							 , spaceAddr 	: vm.spaceModel.spaceAddr
							 , spaceTel	 	: vm.spaceModel.spaceTel
							 , email 	 	: vm.spaceModel.emailId
							 , emailCd		: vm.spaceModel.emailCd
							 , emailEtc 	: (vm.spaceModel.emailCd == '' || vm.spaceModel.emailCd == undefined) ? vm.spaceModel.emailEtc : null
							 , majorLevel 	: vm.spaceModel.facilityMjCd
							 , mediumLevel	: vm.spaceModel.facilityMdCd
							 , spaceEtc		: vm.spaceModel.facilityMdEtc
							 , admittedCnt	: vm.spaceModel.admittedCnt
							 , surfaceArea	: vm.spaceModel.surfaceArea
							 , purpose		: vm.spaceModel.purpose
							 , mentoringYn	: vm.spaceModel.mentoringYn
							 , mentoringDetail : tmp
							 , mentoringEtc : tmpEtc
							 , rentalFee	: vm.spaceModel.rentalFee
							 , managementAgency : vm.spaceModel.managementAgency
							 , url			: vm.spaceModel.url
							 , fileKey		: $('#fileKey').val()
							 , direction	: vm.spaceModel.direction
							 , etc			: vm.spaceModel.etc
							 };
				let param = {param : _param};
				Axios.post("/api/afterschool/space/create", param).then(function(response) {
					let result = response.data.result;
					if(result > 0){
            vm.fnCallImgAltSave('insert');
						swal({
							title      : '등록 성공',
							text       : '등록에 성공하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('success'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								vm.fnChgTab(2, true);
								vm.fnChgValInitBySpc();
							}
						});
					// } else if(resultCnt == -999) {
          } else if(result == -999) {
						swal({
							title      : '등록 실패',
							text       : '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								return false;
							}
						});
					} else {
            console.log(result)
						swal({
							title      : '등록 실패',
							text       : '등록에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					}
				}).catch(function(ex) {
					console.log(ex);
					swal({
						title      : '등록 실패',
						text       : '웹 통신 장애로 인해 등록에 실패했습니다. 관리자에게 문의해주세요.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				});
			}
		},
		//마을공간 수정
		fnChgSpace: function(){
			let vm = this;
			let _mtrDetail = 	(vm.spaceModel.isArea ? "Y" : "N") +'|' +
								(vm.spaceModel.isProgram ? "Y" : "N") +'|' +
								(vm.spaceModel.isEtc ? "Y" : "N");
			let tmp = '';
			if(vm.spaceModel.mentoringYn == 'Y'){
				tmp = _mtrDetail
			}

			let tmpEtc = '';
			if(vm.spaceModel.isEtc){
				tmpEtc = vm.spaceModel.mentoringEtc
			}

			//유효성체크
			let _IsSpaceName	= validation.isEmpty(vm.spaceModel.spaceName);
			let _IsSggCd		= validation.isEmpty(vm.searchModel.sggCd);
			let _IsAddress		= validation.isEmpty(vm.spaceModel.spaceAddr);
			let _IsPhonNum		= validation.isEmpty(vm.spaceModel.spaceTel);
			let _IsEmailId		= validation.isEmpty(vm.spaceModel.emailId);
			let _IsEmailAddr	= false;
			if(vm.spaceModel.emailCd == '' || vm.spaceModel.emailCd == null || vm.spaceModel.emailCd == undefined){
				// _IsEmailAddr	= validation.isEmpty(vm.spaceModel.emailEtc);
        if (vm.spaceModel.emailEtc == '' || vm.spaceModel.emailEtc == null || vm.spaceModel.emailEtc == undefined){
          _IsEmailAddr	= true;
        }
			}
			let _IsMjCd			= validation.isEmpty(vm.spaceModel.facilityMjCd);
			let _IsMdCd			= validation.isEmpty(vm.spaceModel.facilityMdCd);
			let _IsFacilityEtc 	= false;
			if(vm.spaceModel.facilityMdCd == 'FCTNVADMNV01016'
			 || vm.spaceModel.facilityMdCd == 'FCTNVADMNV02006'){
				_IsFacilityEtc 	= validation.isEmpty(vm.spaceModel.facilityMdEtc);
			}
			let _IsAdmittedCnt	= (vm.spaceModel.admittedCnt != null && vm.spaceModel.admittedCnt != undefined && vm.spaceModel.admittedCnt != '') ? validation.isEmpty(String(vm.spaceModel.admittedCnt)) : true;
			let _HasAdmittedCnt	= vm.spaceModel.admittedCnt > 0 ? false : true;
			let _IsSurfaceArea	= (vm.spaceModel.surfaceArea != null && vm.spaceModel.surfaceArea != undefined && vm.spaceModel.surfaceArea != '') ? validation.isEmpty(String(vm.spaceModel.surfaceArea)) : true;
			let _HasSurfaceArea	= vm.spaceModel.surfaceArea > 0 ? false : true;
			let _IsPurpose		= validation.isEmpty(vm.spaceModel.purpose);

			let _IsArea			= false;
			let _IsProgram		= false;
			let _IsEtc			= false;
			let _IsMentoring	= false;
			let _IsMentoringEtc	= false;
			if(vm.spaceModel.mentoringYn == 'Y'){
				_IsArea		= vm.spaceModel.isArea;
				_IsProgram	= vm.spaceModel.isProgram;
				_IsEtc		= vm.spaceModel.isEtc;
				if(!_IsArea && !_IsProgram && !_IsEtc){
					_IsMentoring = true;
				}
				if(vm.spaceModel.isEtc){
					_IsMentoringEtc	= validation.isEmpty(vm.spaceModel.mentoringEtc);
				}
			}

			let _IsRentailFee	= (vm.spaceModel.rentalFee != null && vm.spaceModel.rentalFee != undefined && vm.spaceModel.rentalFee !== '') ? validation.isEmpty(String(vm.spaceModel.rentalFee)) : true;
			let _IsAgency		= validation.isEmpty(vm.spaceModel.managementAgency);

			let _word = '';
			let _resultInput 	= false;
			let _resultChoice 	= false;
			let _comment		= '';
			if(_IsSpaceName){
				_word = '마을공간명';
				_resultInput 	= true;
			} else if(_IsSggCd){
				_word = '지역';
				_resultChoice 	= true;
			} else if(_IsAddress){
				_word = '상세주소';
				_resultInput 	= true;
			} else if(_IsPhonNum){
				_word = '전화번호';
				_resultInput 	= true;
			} else if(_IsEmailId){
				_word = '이메일 계정';
				_resultInput 	= true;
			} else if(_IsEmailAddr){
				_word = '이메일 주소';
				_resultInput 	= true;
			} else if(_IsMjCd){
				_word = '공간 대분류';
				_resultChoice 	= true;
			} else if(_IsMdCd){
				_word = '공간 중분류';
				_resultChoice 	= true;
			} else if(_IsFacilityEtc){
				_word = '공간 분류 기타';
				_resultChoice 	= true;
			} else if(_IsAdmittedCnt){
				_word = '수용인원';
				_resultInput	= true;
			} else if(_HasAdmittedCnt){
				_word = '수용인원';
				_comment		= '1명 이상을 입력해야 됩니다.'
			} else if(_IsSurfaceArea){
				_word = '면적';
				_resultInput 	= true;
			} else if(_HasSurfaceArea){
				_word = '면적';
				_comment		= '0이상의 숫자를 입력해야 됩니다.'
			} else if(_IsPurpose){
				_word = '용도';
				_resultInput 	= true;
			} else if(_IsMentoring){
				_word = '멘토링 가능여부';
				_comment		= '세부 영역 중 1개 이상을 선택해야 됩니다.'
			} else if(_IsMentoringEtc){
				_word = '멘토링 기타(입력)';
				_resultInput 	= true;
			} else if(_IsRentailFee){
				_word = '대관료';
				_resultInput 	= true;
			} else if(_IsAgency){
				_word = '운영기관';
				_resultInput 	= true;
			}

			if (_resultChoice){
				swal({
					title       : _word+' 오류',
					text        : _word+'을/를 선택해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else if( _resultInput) {
				swal({
					title       : _word+' 오류',
					text        : _word+'을/를 입력해주세요.',
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else if( _HasAdmittedCnt || _IsMentoring || _HasSurfaceArea) {
				swal({
					title       : _word+' 오류',
					text        : _comment,
					icon        : this.fnOnLoadSwalImageData('error'),
					buttons: {
						cancel: {
							text: "Cancel",
							value: false,
							visible: false,
						},
						confirm: {
							text: "Ok",
							value: true,
							visible: true,
						}
					},
					dangerMode  : true,
				}).then(result => {
					return false;
				});
			} else {
				let _param = { spaceName 	: vm.spaceModel.spaceName
							 , sggCd	 	: vm.searchModel.sggCd
							 , spaceAddr 	: vm.spaceModel.spaceAddr
							 , spaceTel	 	: vm.spaceModel.spaceTel
							 , email 	 	: vm.spaceModel.emailId
							 , emailCd		: vm.spaceModel.emailCd
							 , emailEtc 	: vm.spaceModel.emailCd == '' ? vm.spaceModel.emailEtc : null
							 , majorLevel	: vm.spaceModel.facilityMjCd
							 , mediumLevel	: vm.spaceModel.facilityMdCd
							 , spaceEtc		: vm.spaceModel.facilityMdEtc
							 , admittedCnt	: vm.spaceModel.admittedCnt
							 , surfaceArea	: vm.spaceModel.surfaceArea
							 , purpose		: vm.spaceModel.purpose
							 , mentoringYn	: vm.spaceModel.mentoringYn
							 , mentoringDetail : tmp
							 , mentoringEtc : tmpEtc
							 , rentalFee	: vm.spaceModel.rentalFee
							 , managementAgency : vm.spaceModel.managementAgency
							 , url			: vm.spaceModel.url
							 , fileKey		: $('#fileKey').val()
							 , direction	: vm.spaceModel.direction
							 , etc			: vm.spaceModel.etc
							 , uidKey		: vm.spaceModel.uidKey
							 };
				let param = {param : _param};
				Axios.post("/api/afterschool/space/update", param).then(function(response) {
					let result = response.data.result;
					if(result > 0){
            vm.fnCallImgAltSave('update');
						swal({
							title      : '',
							text       : '수정에 성공하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('success'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								vm.fnChgValInitBySpc();
								vm.fnChgTab(2,true);
								// location.reload();
							}
						});
					// } else if(resultCnt == -999) {
          } else if(result == -999) {
						swal({
							title      : '수정 실패',
							text       : '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						}).then(result => {
							if(result){
								return false;
							}
						});
					} else {
						swal({
							title      : '',
							text       : '수정에 실패하였습니다.',
							icon       : vm.fnOnLoadSwalImageData('error'),
							buttons: {
								cancel: {
									text: "Cancel",
									value: false,
									visible: false,
								},
								confirm: {
									text: "Ok",
									value: true,
									visible: true,
								},
							},
							dangerMode : true
						});
						return false;
					}
				}).catch(function(ex) {
					console.log(ex);
					swal({
						title      : '',
						text       : '수정에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				});
			}
		},
		//마을공간 초기화
		fnChgValInitBySpc: function(click) {
			let vm = this;
			vm.spaceModel.facilityMjCd		= '';
			vm.spaceModel.facilityMjName	= '';
			vm.spaceModel.facilityMdCd		= '';
			vm.spaceModel.facilityMdName	= '';
			vm.spaceModel.facilityMdEtc		= '';
			vm.spaceModel.spaceName		 	= '';
			vm.spaceModel.spaceAddr		 	= '';
			vm.spaceModel.spaceTel		 	= '';
			vm.spaceModel.spaceEmail		= '';
			vm.spaceModel.majorLevel		= '';
			vm.spaceModel.mediumLevel		= '';
			vm.spaceModel.admittedCnt		= '';
			vm.spaceModel.surfaceArea		= '';
			vm.spaceModel.purpose		 	= '';
			vm.spaceModel.rentalFee		 	= '';
			vm.spaceModel.mentoringYn		= 'N';
			vm.spaceModel.managementAgency	= '';
			vm.spaceModel.url		 		= '';
			vm.searchModel.sggName		 	= '';
			vm.searchModel.sggCd		 	= '';
			vm.spaceModel.sggCd		 		= '';
			vm.spaceModel.emailId			= '';
			vm.spaceModel.emailAddr		 	= '';
			vm.spaceModel.emailCd		 	= '';
			vm.spaceModel.emailEtc			= '';
			vm.searchModel.keyword			= '';
			vm.searchModel.emailCdList		= [];
			vm.searchModel.sggCdList		= [];
			vm.programModel.programList		= [];
			vm.searchModel.isMentoring		= false;
			vm.spaceModel.etc				= '';
			vm.spaceModel.direction			= '';
			vm.spaceModel.mentoringEtc		= '';
			vm.spaceModel.mentoringDetail	= '';
			vm.phoneNumberBySpaceApply		= '';
			vm.selectEmailBoxInSpaceApply   = { code: "", value: "" };
			vm.selectMajorBoxInSpaceApply	= { code: "", value: "" };
			vm.selectMediumBoxInSpaceApply	= { code: "", value: "" };
			vm.selectMajorBoxInSpaceSearch	= { code: "", value: "" };
			vm.selectMediumBoxInSpaceSearch	= { code: "", value: "" };
			vm.admittedCntNumberBySpaceApply = '';
			vm.surfaceAreaFloatBySpaceApply	= '';
			vm.spaceModel.isArea			= false;
			vm.spaceModel.isProgram			= false;
			vm.spaceModel.isEtc				= false;
			vm.spaceModel.tmpEtc			= '';
			vm.spaceModel.tmpDirection		= '';
			vm.spaceModel.addr				= '';
			vm.spaceModel.emailEtc			= '';

			vm.mapViewModel.mapInit			= 0;
			if(vm.menuViewModel.cnt != 0){
				vm.menuViewModel.cnt		= 1;
			}
			if(click == 'on'){
				vm.searchModel.facilityMediumCdList = [];
			}
			vm.fileImgList					= [];
		},
		//멘토링 가능 여부 체크
		fnChkMentoringYn: function(){
			this.searchModel.isMentoring = !this.searchModel.isMentoring;
			// this.fnGetAfterSchoolSpcCntBySggList();
			// this.fnGetAfterSchoolSpcList(1);
		},
		//마을공간 검색
		fnGetSearchBySpace: function(){
			this.fnGetAfterSchoolSpcCntBySggList();

			if (sessionStorage.getItem('afterSpace.search') != null) {
				this.fnGetAfterSpaceSearchSessionStorage();
			}
			else {
				this.fnGetAfterSchoolSpcList(1);
			}

			this.menuViewModel.isClick = true;
		},
		//구별 마을방과후 공간 건수 조회
		fnGetAfterSchoolSpcCntBySggList: function() {
			let vm = this;
			let _sggCd = '';
			let _tmpSggCd = $('#sggCd').val();
			if(_tmpSggCd != null && _tmpSggCd != ''){
				_sggCd = '';
			} else {
				_sggCd = vm.searchModel.sggCd
			}
			let _param = { sggCd: _sggCd
						 , facilityMjCd : vm.searchModel.facilityMjCd
						 , facilityMdCd : vm.searchModel.facilityMdCd
						 , mentoringYn : (vm.searchModel.isMentoring ? "Y" : "")
						 , keyword	: vm.searchModel.keyword
						 };
			let param = {param : _param};
			Axios.post("/api/afterschool/space/sggcnt/list", param).then(function(response) {
				vm.mainModel.fndSpcBySggList = response.data.paramCdDtoList;
				vm.fnChgVal();
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마을공간 상세
		fnGetAfterSchoolSpaceDetail: function(pageNumber, _uidKey){
			let vm = this;
			// vm.viewModel.pager.rowSize = 6;
			// vm.viewModel.pager.blockSize = 5;
			// vm.viewModel.pager.pageNo = pageNumber;
			let _param = {uidKey: _uidKey};
			let param = { param : _param
				    	// , pageNo: vm.viewModel.pager.pageNo
				     	// , pageSize: vm.viewModel.pager.rowSize
				    	};
			Axios.post("/api/afterschool/space/detail", param).then(function(response) {
				vm.spaceModel = response.data.paramSpcDto;
				vm.spaceModel.addr = vm.spaceModel.spaceAddr;
				vm.spaceModel.emailAddr = (vm.spaceModel.emailEtc != null && vm.spaceModel.emailEtc != '') ? vm.spaceModel.emailEtc : vm.spaceModel.emailAddr;

				if(vm.spaceModel.email == null || vm.spaceModel.email == undefined || vm.spaceModel.email == '' ){
					vm.spaceModel.spaceEmail = '이메일 주소 없음' ;
				} else {
					vm.spaceModel.spaceEmail = (vm.spaceModel.email + '@' + ((vm.spaceModel.emailCd != null && vm.spaceModel.emailCd != '') ? vm.spaceModel.emailAddr : vm.spaceModel.emailEtc));
				}
				if(response.data.fileImgList != null || response.data.fileImgList != undefined){
					response.data.fileImgList.forEach(function(file){
						file.fileUrl = "/img/" + file.file_new_name.substr(0,8) + "/" + file.file_new_name;
					});
					vm.fileImgList = response.data.fileImgList;
				}

				vm.spaceModel.tmpEtc 		= vm.fnChgLine(vm.spaceModel.etc);
				vm.spaceModel.tmpDirection 	= vm.fnChgLine(vm.spaceModel.direction);
				vm.spaceModel.spaceTel 		= vm.fnChgTelNum(vm.spaceModel.spaceTel);

				if(vm.spaceModel.mentoringYn == 'Y'){
					let tmpArr = vm.spaceModel.mentoringDetail.split('\|');
					if(tmpArr[0] == "Y"){
						vm.spaceModel.isArea  = true;
						vm.spaceModel.areaYn  = '제공';
					} else {
						vm.spaceModel.isArea  = false;
						vm.spaceModel.areaYn  = '미제공';
					}

					if(tmpArr[1] == "Y"){
						vm.spaceModel.isProgram  = true;
						vm.spaceModel.programYn	 = '제공';
					} else {
						vm.spaceModel.isProgram  = false;
						vm.spaceModel.programYn	 = '미제공';
					}

					if(tmpArr[2] == "Y"){
						vm.spaceModel.isEtc  = true;
					} else {
						vm.spaceModel.isEtc  = false;
					}
				}
				vm.spaceModel.tmpEmail = vm.spaceModel.emailEtc;
				// response.data.paramPrgmDtoList.forEach(function (object) {
				// 	if(object.zzimYn == 'Y'){
				// 		object.isZzim = true;
				// 	} else {
				// 		object.isZzim = false;
				// 	}
				// 	let today = new Date();
				// 	let startDate = object.acceptStartDate;
				// 	let endDate = object.acceptEndDate;
				// 	if(startDate >= today){
				// 		if(endDate > today){
				// 			object.status = 'finish';
				// 		} else {
				// 			object.status = 'ing';
				// 		}
				// 	} else {
				// 		object.status = 'before';
				// 	}

				// 	vm.programModel.programList.push(object);
				// });
				//vm.fnSetPager(response.data.paramListCnt, 'fnGetAfterSchoolSpaceDetail');
			}).catch(function(ex) {
				console.log(ex);
			});

		},
		//alert 이미지 호출
        fnOnLoadSwalImageData:function(value){
            let _icon = "/design/common/images/sub/img_alert_"+value+".png";
            return _icon;
        },
		//마을강사찾기 페이지
		fnGetAfterTeacherSearchPage: function(){
			let vm = this;
			let _sggCd = $('#sggCd').val();
			if(_sggCd != null && _sggCd !=''){
				vm.searchModel.sggCd = _sggCd;
			}
			vm.fnGetAfterSchoolTchrCntBySggList();
			vm.fnChgSubTabByTchr(1);
		},
		//마을공간 페이지
		fnGetAfterSpaceSearchPage: function(){
			let vm = this;
			let _sggCd = $('#sggCd').val();
			if(_sggCd != null && _sggCd !=''){
				vm.searchModel.sggCd = _sggCd;
			}
			vm.fnChgSubTabBySpc(1);
			vm.menuViewModel.cnt++;
		},
		//마을공간페이지 검색 초기화
		fnChgSearchBySpc: function(){
			let vm = this;
      $("#sggCd").val(''); // sggCd 가 url 파라미터로 있는 경우 초기화를 위해 추가
			vm.fnChgValInitBySpc('on');
			vm.fnGetAfterSchoolSpcCntBySggList();
			vm.fnGetAfterSchoolSpcList(1);
			vm.fnOnChangeMap();
			// vm.fnChgTab(2);
		},

		//마을공간 등록시 이미지 파일키 호출
		fnGetImgFileKeyBySpace: function(){
			let vm = this;
			let _param = {};
			let param = { param : _param};
			Axios.post("/api/afterschool/space/imgFileKey", param).then(function(response) {
				$('#fileKey').val(response.data.fileKey);
			});
		},

		//마을공간 수정 페이지 조회
		fnUpdateSpace:function(vo){
			let vm = this;
			vm.spaceModel.tmpEmailCd = vo.emailCd;
			vm.spaceModel = vo;
			//상세정보 조회
			// vm.fnGetAfterSchoolSpaceDetail(1, uidKey);

			setTimeout(() => {
				vm.fnChgTab(1 , false);
				vm.phoneNumberBySpaceApply 			= vm.spaceModel.spaceTel;
				vm.spaceModel.emailId				= vm.spaceModel.email;
				vm.admittedCntNumberBySpaceApply 	= vm.spaceModel.admittedCnt;
				vm.surfaceAreaFloatBySpaceApply		= vm.spaceModel.surfaceArea;
				vm.spaceModel.emailEtc				= vo.tmpEmail;
				vm.spaceModel.spaceAddr				= vm.spaceModel.addr;
			}, 500);

		},

		//연락처체크-강사등록
		fnOnChkTelByTeacherApply: function(e){
			let vm = this;
			vm.phoneNumberByTeacherApply = e.target.value;
		},
		//연락처체크-공간등록
		fnOnChkTelBySpaceApply: function(e){
			let vm = this;
			vm.phoneNumberBySpaceApply = e.target.value;
		},
		//수용인원체크-강사등록
		fnOnChkAddmittedCntBySpaceApply: function(e){
			let vm = this;
			vm.admittedCntNumberBySpaceApply = e.target.value;
		},
		//면적체크-강사등록
		fnOnChkAreaBySpaceApply: function(e){
			let vm = this;
			vm.surfaceAreaFloatBySpaceApply = e.target.value;
		},
		//////////유효성체크//////////
		//마을공간등록-유효성체크
		fnOnChangeCheckSpaceName:function(){
			// let vm = this;
            // let _valid = vm.spaceModel.spaceName;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid, '마을공간명은 필수항목입니다.' ) : '';
			// vm.spaceModel.isSpaceName = vm.spaceModel.spaceName != '' ? true : false;
        },
		fnOnChangeCheckSggCd:function(){
			// let vm = this;
            // let _valid = vm.searchModel.sggCd;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid,'지역선택은 필수항목입니다.' ) : '';
			// vm.spaceModel.isSggCd = vm.searchModel.sggCd != '' ? true : false;
        },
		fnOnChangeCheckSpaceAddr:function(){
			// let vm = this;
            // let _valid = vm.spaceModel.spaceAddr;
            // vm.spaceModel.validateTxtSpaceName = ( _valid == '') ? Validator.methods.fnValidateTxtEmpty(_valid, '주소는 필수항목입니다.' ) : '';
			// vm.spaceModel.isSpaceAddr = vm.spaceModel.spaceAddr != '' ? true : false;
        },

		fnValidateChk:function(validateObj){
            let vm = this;
            let chkLegnth = 0;
            for(let item in validateObj){
                if(validateObj[item] == false){
                    chkLegnth++;
                    vm.$refs[item].focus();
                    break;
                }
            }
            return chkLegnth;
        },
		//좋아요 처리
        fnChgLikeBtn: function(object){
            //로그인 체크
            let vm = this;
            let _userKey = $("#loginUserKey").val();

            if (this.fnIsEmptyChk(_userKey)) {
                swal({
                    title      : '',
                    text       : '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    icon       : vm.fnOnLoadSwalImageData('info'),
                    buttons    : true,
                    dangerMode : true
                }).then(result => {
                    if(result){
                        location.href = "/youthnavi/signup/login";
                    }
                });
            } else {
                //로그인이 되어 있으면
                object.isLike = !object.isLike;
                vm.programModel.review.isLike = object.isLike;
                let _param = { uidKey        : object.uidKey
                             , rcmmUidKey    : object.rcmmUidKey
                             , isLike        : object.isLike
                             };
                let param = {param:_param};
                Axios.post("/api/realinfo/contents/like/update", param).then(function(response) {
                  let result = response.data.result
                }).catch(function(ex) {
                  console.log(ex);
                });
            }
        },
		// onClickAfterSpaceDetail : function(uidKey){
		// 	location.href="/customer/afterschool/space?tab=2&uidKey="+uidKey;
		// },
		onClickAfterSpaceCreate : function(uidKey){
			location.href="/customer/afterschool/space?tab=1";
		},
		//파일키 호출
		fnGetFileKey: function(){
			let vm = this;
			let _param = {};
			let param = {param:_param};
			Axios.post("/api/afterschool/fileKey/create", param).then(function(response) {
				vm.fileKey = response.data.fileKey;
				$('#fileKey').val(vm.fileKey);
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//전화번호하이픈
		fnChgTelNum : function(telNum){
			let vm = this;
			let result = [];
			let restNumber = '';

			if(!telNum){
				return "";
			}
			let value = telNum.replace(/[^0-9]/g, "");
			// 지역번호와 나머지 번호로 나누기
			if(value.length === 12){
				result.push(value.substring(0, 4));
				result.push(value.substring(4, 8));
				result.push(value.substring(8, 12));
			} else {
				if (value.startsWith("02")) {
					// 서울 02 지역번호
					result.push(value.substr(0, 2));
					restNumber = value.substring(2);
				} else if (value.startsWith("1")) {
					// 지역 번호가 없는 경우
					// 1xxx-yyyy
					restNumber = value;
				} else {
					// 나머지 3자리 지역번호
					// 0xx-yyyy-zzzz
					result.push(value.substr(0, 3));
					restNumber = value.substring(3);
				}

				if (restNumber.length === 7) {
					// 7자리만 남았을 때는 xxx-yyyy
					result.push(restNumber.substring(0, 3));
					result.push(restNumber.substring(3));
				} else {
					result.push(restNumber.substring(0, 4));
					result.push(restNumber.substring(4));
				}
			}
			let tmpTel = result.filter((val) => val).join("-");
			return tmpTel;
		},
		//마을공간 게시여부 변경
		fnChgAprvYn: function(value, _uidKey){
			let vm = this;
			let _param = { approveYn:value
						 , uidKey:_uidKey}
			let param = {param:_param};
			Axios.post("/api/mynavi/afterschool/spaceApproval", param).then(function(response) {
				let result = response.data.result;
				let tmp = '';
				if(value == 'Y'){
					tmp = '게시'
				} else {
					tmp = '미게시'
				}

				if (result > 0) {
					swal({
						title      : '',
						text       : tmp+'처리 되었습니다.',
						icon       : vm.fnOnLoadSwalImageData('success'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					}).then(result => {
						if(result){
							location.reload();
						}
					});
				} else {
					swal({
						title      : '',
						text       : tmp+'처리에 실패하였습니다.',
						icon       : vm.fnOnLoadSwalImageData('error'),
						buttons: {
							cancel: {
								text: "Cancel",
								value: false,
								visible: false,
							},
							confirm: {
								text: "Ok",
								value: true,
								visible: true,
							},
						},
						dangerMode : true
					});
					return false;
				}
			}).catch(function(ex) {
				console.log(ex);
			});
		},
		//마이내비 마을공간 상세
		onClickSpaceDetail: function(uidKey){
      this.fnSetAfterSpaceListSessionStorage();
			location.href="/customer/afterschool/space?uidKey="+uidKey;
		},
		//마을공간 삭제
		onClickSpaceDelete: function(uidKey){
			let vm = this;
			let _param = {uidKey:uidKey};
			let param = { param : _param};
			swal({
				title      : '',
				text       : '삭제하시겠습니까?',
				icon       : vm.fnOnLoadSwalImageData('info'),
				buttons: {
					cancel: {
						text: "Cancel",
						value: false,
						visible: true,
					},
					confirm: {
						text: "Ok",
						value: true,
						visible: true,
					},
				},
				dangerMode : true
			}).then(result => {
				if(result){
					Axios.post("/api/afterschool/space/delete", param).then(function(response) {
						let result = response.data.result;
						if (result > 0) {
							swal({
								title      : '',
								text       : '삭제 되었습니다.',
								icon       : vm.fnOnLoadSwalImageData('success'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							}).then(result => {
								if(result){
									location.reload();
								}
							});
						} else {
							swal({
								title      : '',
								text       : '삭제에 실패하였습니다.',
								icon       : vm.fnOnLoadSwalImageData('error'),
								buttons: {
									cancel: {
										text: "Cancel",
										value: false,
										visible: false,
									},
									confirm: {
										text: "Ok",
										value: true,
										visible: true,
									},
								},
								dangerMode : true
							});
							return false;
						}
					});
				}
			});
		},
		//엑셀다운로드
        fnOnClickExcelDownload:function(){
            let vm = this;
            let param = { paramName : 'AFTSC00300'};
            Axios.post("/api/excel/download", param).then(function(response) {
                let _preColName = response.data.paramcolName;
                let _preColNameArr = (_preColName != null) ? _preColName.split('NV').join(',') : [];
                let _list = response.data.excelList;
                let _sheetName =  '마을공간 등록내역';
                let _downloadName = '마을공간 등록내역';
                if(_preColNameArr.length > 0 && _list.length > 0){
                    let convertColName = Excel.methods.fnCreateExcelColumn(_preColNameArr);
                    Excel.methods.fnOnClickExcelDownload(_list, convertColName, _sheetName, _downloadName);
                }
            }).catch(function(ex) {
                console.log(ex);
            });
        },
		//textarea 줄바꿈 처리
		fnChgLine: function(text){
			let tmp = text.split('\n').join('<br/>');
			return tmp;
		},
		scrollToTop() {
            window.scrollTo(0,0);
        },
		onClickAfterSpaceSearchTab: function(){
			location.href="/customer/afterschool/space?tab=2";
		},
		onClickAfterSpaceDetail: function(uidKey){
			this.fnSetAfterSpaceSearchSessionStorage();
			location.href="/customer/afterschool/space?tab=2&uidKey="+uidKey;
		}
    , fnCallImgAltSave:function (type) { // 이미지 alt 저장
      if (type === 'insert')
        this.$refs.dropimg_i.fnParentSaveCB()
      else
        this.$refs.dropimg_u.fnParentSaveCB()
    }
	}
});
